import { RocketPurple } from "components/icons/RocketPurple";
import { VerticalDivider } from "components/design/VerticalDivider";

export const Upgrade = ({
  onUpgrade,
  enableDivider,
}: {
  onUpgrade: () => void;
  enableDivider?: boolean;
}) => {
  return (
    <div className="t-flex t-items-center t-gap-2">
      <div
        onClick={onUpgrade}
        className="moving_border_upgrade t-cursor-pointer t-flex t-text-purple t-items-center t-gap-2 t-text-body-sm t-font-medium"
      >
        <RocketPurple height={16} width={16} />
        Upgrade
      </div>
      {enableDivider && <VerticalDivider />}
    </div>
  );
};
